import { createThemedUseStyles } from "theme";

export default createThemedUseStyles((theme) => ({
    smLeftPad: {
        paddingLeft: theme.paddingScale.xsmall
    }
}));
